import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';

import { PregledFakturaComponent } from './pregled-faktura.component';

import { TabsModule } from 'beyond-util';

@NgModule({
  declarations: [PregledFakturaComponent],
  entryComponents: [PregledFakturaComponent],
  exports: [PregledFakturaComponent],
  imports: [
    CommonModule,
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    HttpClientModule,
    TabsModule,
  ],
})
export class PregledFakturaModule {}



// WEBPACK FOOTER //
// ./src/app/pages/pregled-faktura/pregled-faktura.module.ts